var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c(
        "div",
        {
          staticClass: "col-md-12 menu-header",
          class: {
            "disable-content": _vm.disableContent || _vm.importProgressStatus,
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "col-xs-12 p-0 d-flex header-container align-items-center justify-space-between xs-flex-column",
            },
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass:
                    "search-container-parent d-flex col-xs-12 col-sm-6 col-md-5 col-gap-20 p-0",
                },
                [
                  _vm.permissions.includes(
                    "REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT_SEARCH"
                  )
                    ? _c(
                        "div",
                        {
                          staticClass: "search-container p-0",
                          class: [
                            _vm.permissions.includes(
                              "REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT_CREATE_NEW_ALERT"
                            )
                              ? "col-xs-10"
                              : "col-xs-12",
                          ],
                        },
                        [
                          _c("search-box", {
                            model: {
                              value: _vm.alertSearch,
                              callback: function ($$v) {
                                _vm.alertSearch = $$v
                              },
                              expression: "alertSearch",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.permissions.includes(
                    "REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT_CREATE_NEW_ALERT"
                  )
                    ? _c(
                        "button",
                        {
                          staticClass: "btn emergo-green-button",
                          on: { click: _vm.addAlertModal },
                        },
                        [_vm._m(1)]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "col-xs-12 d-flex justify-space-between align-items-center p-0 count-section",
            },
            [
              !_vm.alertSearch.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "reg-watch-count font-18 text-secondary mb-0 fw-400",
                    },
                    [_vm._v(" " + _vm._s(_vm.gridData.length) + " alerts ")]
                  )
                : _vm.alertSearch.length
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "reg-watch-count font-18 text-secondary mb-0 fw-400",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.searchResultCount) +
                            " result(s) found "
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "text-secondary font-16" }, [
                      _vm._v(
                        "out of " + _vm._s(_vm.gridData.length) + " alerts"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.permissions.includes(
                "REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT_SELECT/DELETE"
              )
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-delete font-18 p-0 d-flex align-items-center col-gap-10 fw-400",
                      attrs: { disabled: _vm.selectedAlert.length == 0 },
                      on: { click: _vm.confirmDeleteRegistrations },
                    },
                    [
                      _c("i", { staticClass: "fa fa-trash" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Delete")]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "col-xs-12 col-sm-12 col-md-12",
          staticStyle: { padding: "0" },
        },
        [
          _c("alert-data-grid", {
            attrs: {
              permissions: _vm.permissions,
              disableContent: _vm.disableContent || _vm.importProgressStatus,
              refreshDataAfterDelete: _vm.refreshDataAfterDelete,
              loadingStatus: _vm.loaderStatus,
              data: _vm.gridData,
              "filter-key": _vm.alertSearch,
              selectedAlertList: _vm.selectedAlert,
              clearSelection: _vm.clearSelection,
            },
            on: {
              selectedAlertListChanged: _vm.selectedAlertListChanged,
              searchResult: _vm.SetSearchResult,
              setSearch: _vm.setSearch,
              regulatoryAlertClicked: _vm.regulatoryAlertClicked,
            },
          }),
        ],
        1
      ),
      _c("alert-popup", {
        attrs: {
          regulatoryAlertData: _vm.selectedRegulatoryAlert,
          newRegulatoryAlert: _vm.newRegulatoryAlertFlag,
          reviewAlertFlag: _vm.reviewAlertFlag,
          editRegulatoryAlert: _vm.editRegulatoryAlertFlag,
        },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _c("delete-alert-popup", {
        attrs: { selectedAlerts: _vm.selectedAlert },
        on: { loadRegistrationData: _vm.loadAlertDataAfterDelete },
      }),
      _c("import-progress-bar", {
        attrs: {
          mode: _vm.mode,
          progressStatus: _vm.importProgressStatus,
          percentage: _vm.importPercentage,
        },
        on: { updateImportProgressStatus: _vm.updateImportProgressStatus },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "page-title d-flex align-items-center col-xs-12 col-sm-6 col-md-7 p-0",
      },
      [
        _c("img", {
          attrs: { src: "/static/images/icons/vector_stoke_left_blue.svg" },
        }),
        _vm._v("Regulatory Watch Admin "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "d-flex align-items-center btn-container" },
      [
        _c("img", {
          attrs: { src: "/static/images/icons/add.svg", alt: "add-icon" },
        }),
        _c("span", { staticClass: "pl-5 xs-hide" }, [_vm._v("Add Alert")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }